import React from "react";
import styles from '../styles/headerNav.module.scss'
import { useTranslation } from "react-i18next";
import { IconName } from "@/wmCompoments/Icon/iconTypes";
import Icon from "@/wmCompoments/Icon";

const HeaderNav = ({onButtonClick, activeIndex}) => {
  const { t } = useTranslation('inviteFriends')
  const buttons = [
    {
      icon: 'icon-invite-invite',
      title: t('inviteAllReward'), 
    },
    {
      icon: 'icon-invite-reward',
      title: t('inviteAllReward'), 
    },
    {
      icon: 'icon-invite-deposit',
      title: t('cashDailyEarn'), 
    },
  ]

  return (
    <div className={styles.buttons}>
      {buttons.map((v,index)=>{
        return <button key={index} onClick={()=>onButtonClick(index)} className={`${styles.button} ${index === activeIndex ? styles.active : ''}`}>
          <Icon name={v.icon as IconName} className={styles.icon} />
          <div>{v.title}</div>
        </button>
      })}
    </div>
  )
}

export default HeaderNav